import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { UIRouterModule } from '@uirouter/angular';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { ComponentsModule } from '../components/components.module';
import { SharedModule } from '../shared/shared.module';
import { AuthModule } from '../auth/auth.module';

import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { CodeInputModule } from 'angular-code-input';
import { FolderPathComponent } from "../components/folders/folder-path/folder-path.component";
import { SearchFilterComponent } from '../components/search-filter/search-filter.component';
import { ModeratorJoinComponent } from './components/moderator-join/moderator-join.component';
import { ModeratorRoomComponent } from './components/moderator-room/moderator-room.component';
import { ScreenSharingControlsComponent } from './components/screen-sharing-controls/screen-sharing-controls.component';
import { ScreenSharingComponent } from './components/screen-sharing/screen-sharing.component';
import { routes } from './screen-sharing.routes';
import { ViewportComponent } from './viewport/viewport.component';

@NgModule({
  declarations: [
    ModeratorJoinComponent,
    ModeratorRoomComponent,
    ScreenSharingComponent,
    ScreenSharingControlsComponent,
    ViewportComponent
  ],
  imports: [
    UIRouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    ComponentsModule,
    SharedModule,
    AuthModule,
    PopoverModule.forRoot(),
    MatSlideToggleModule,
    MatCheckboxModule,
    MatButtonModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatDividerModule,
    MatFormFieldModule,
    MatTabsModule,
    MatChipsModule,
    MatSelectModule,
    CodeInputModule,
    FolderPathComponent,
    SearchFilterComponent
]
})
export class ScreenSharingModule {
}
